import { Message, MessageBox  } from 'element-ui'

const dialog = {
    success: function (msg) {
        Message({
            message: msg,
            type: 'success'
        });
    },
    msg: function (msg) {
        Message(msg);
    },
    errormsg: function (msg) {
        Message({
            message: msg,
            type: 'error'
        });
    },
    error: function (msg) {
        MessageBox({
            title:'错误',
            message:msg,
            type:'error'
        });
    },
    alert: function (msg) {
        MessageBox({
            title:'提示',
            message:msg
        });
    },
    confirm:function(msg,callback1,callback2){
        MessageBox({
            title:'确认',
            type:'warning',
            message:msg,
            showCancelButton:true,
            showConfirmButton:true,
            callback:function(action){
                if(action=='confirm'){
                    if(callback1){
                        callback1();
                    }
                }else{
                    if(callback2){
                        callback2();
                    }
                }
            }
        });
    }
}
export default dialog


// WEBPACK FOOTER //
// ./src/common/js/dialog.js